// Live useAgentChat writer count.
//
// Home and Image Studio mount useAgentChat. The shell panel reads
// this count and does not mount a second writer. Registration is in
// an effect so React 18 StrictMode (setup → cleanup → setup) leaves
// the count at one. The panel also refuses to mount a writer when
// the count is still zero, because useAgentChat's storage key is
// shared and a late count must not be the only guard.

import { useEffect, useSyncExternalStore } from 'react';

let writerCount = 0;
const listeners = new Set<() => void>();

export function getAgentChatWriterCount(): number {
  return writerCount;
}

export function subscribeAgentChatWriters(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function emit(): void {
  for (const listener of listeners) listener();
}

export function useRegisterAgentChatWriter(): void {
  // Effect-only. Incrementing during render is impure: StrictMode
  // invokes the render twice and the extra increment sticks. Setup,
  // cleanup, setup leaves the count at one.
  useEffect(() => {
    writerCount += 1;
    emit();
    return () => {
      writerCount -= 1;
      emit();
    };
  }, []);
}

export function useAgentChatWriterCount(): number {
  return useSyncExternalStore(
    subscribeAgentChatWriters,
    getAgentChatWriterCount,
    getAgentChatWriterCount
  );
}
